import { Badge, type BadgeProps } from "@mantine/core";
// Imported, not re-declared. This file used to carry its own copy of the union,
// which meant the vocabulary lived in three places (here, api/types.ts and the
// zod enum in lib/schemas.ts) and a state added or removed on the wire only
// broke two of them. Nothing imported the local copy, so folding it costs
// nothing and leaves the schema as the single wire contract.
import type { BatchState } from "../api/types";

const STATE_COLOR: Record<BatchState, BadgeProps["color"]> = {
  Open: "gray",
  PendingApproval: "yellow",
  Approved: "teal",
};

/** Display label per state. Exported so nothing has to keep a second copy —
 * LifecycleActions used to, and the two could drift. */
export const STATE_LABEL: Record<BatchState, string> = {
  Open: "Open",
  PendingApproval: "Pending Approval",
  Approved: "Approved",
};

export function BatchStateBadge({ state }: { state: BatchState }) {
  return (
    <Badge color={STATE_COLOR[state]} variant="light" radius="sm">
      {STATE_LABEL[state]}
    </Badge>
  );
}
